import React, { Component } from 'react'
import { isArray, isEmpty, isEqual } from 'lodash'
import { translate } from 'react-i18next'
import onClickOutside from 'react-onclickoutside'
import { withRouter } from 'react-router-dom'
import Error from './Error'
import RecursiveElement from './RecursiveElement'
import Spinner from './Spinner'

// FIXME: memory leaks - every constructor call generates random pagination target
// FIXES: garbage collector? remove pagination on unmount? better target mapping?

// https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
function uuidv4() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

class VCBasicGrid extends Component {
  constructor(props) {

    let taxonomy
    if (props.showFilter && props.location.hash && props.location.hash.indexOf('#taxonomy-') === 0) {
      taxonomy = parseInt(props.location.hash.replace('#taxonomy-', ''), 10)
      if (!props.taxonomies.find(_taxonomy => _taxonomy === taxonomy)) taxonomy = undefined
    }
    super(props)
    this.state = {
      grid: null,
      posts: null,
      catsByTarget: null,
      error: null,
      target: 'VCBasicGrid_' + uuidv4(),
      // if filter is disabled or filterSize is lg then get post from all taxonomies, else get only first taxonomy!
      cats: taxonomy !== undefined ? [taxonomy] : (!props.showFilter || props.filterSize === 'lg') ? [props.taxonomies[0]] : [props.taxonomies[0]], // FIXME: taxonomies not always are cats!
      month: null,
      year: null,
      limit: props.paginationStyle ? props.number : props.limit,
      currentPage: 1, // FIXME: should be set by API response (as nextPage is set)
      nextPage: null,
      isFetching: null,
      toggleTabs: false // FIXME: remove from VCBasicGrid Component
    }

    if (props.grids[props.gridId] === undefined)
      props.getGrid(props.gridId)

    if (isEmpty(props.cats.items) || (props.cats.code !== null && props.cats.code !== 200))
      props.findAllCats()

    if (props.pagination[this.state.target] === undefined)
      props.findPosts({
        target: this.state.target,
        reset: true,
        cats: this.state.cats,
        limit: this.state.limit
      })
      this.gridRef = React.createRef();
  }

  // FIXME: move to saga?
  dateRange = () => {
    if (this.state.month !== null) {
      const year = this.state.year /*|| (new Date()).getFullYear()*/
      return {
        after: new Date(year, this.state.month, 1),
        before: new Date(year, this.state.month + 1, 0)
      }
    }

    if (this.state.year !== null) {
      return {
        after: new Date(this.state.year, 0, 1),
        before: new Date(this.state.year, 12, 0)
      }
    }

    return {
      after: undefined,
      before: undefined
    }
  }

  handlePrevPage = e => {
    e.preventDefault()
    const { before, after } = this.dateRange()
    this.props.findPosts({
      target: this.state.target,
      reset: true,
      cats: this.state.cats,
      before,
      after,
      page: this.state.currentPage - 1,
      limit: this.state.limit
    })
    this.setState({
      currentPage: this.state.currentPage - 1
    })
    window.scrollBy(0, this.gridRef.current.getBoundingClientRect().y - 100)
  }

  handleNextPage = e => {
    e.preventDefault()
    const { before, after } = this.dateRange()
    this.props.findPosts({
      target: this.state.target,
      reset: true,
      cats: this.state.cats,
      before,
      after,
      page: this.state.nextPage || undefined,
      limit: this.state.limit
    })
    this.setState({
      currentPage: this.state.nextPage || 1
    })
    window.scrollBy(0, this.gridRef.current.getBoundingClientRect().y - 100)
  }

  handlePageChange = e => {
    e.preventDefault()
    const page = parseInt(e.target.getAttribute('data-page'), 10)
    const { before, after } = this.dateRange()
    this.props.findPosts({
      target: this.state.target,
      reset: true,
      cats: this.state.cats,
      before,
      after,
      page,
      limit: this.state.limit
    })
    this.setState({
      currentPage: page
    })
    window.scrollBy(0, this.gridRef.current.getBoundingClientRect().y - 100)
  }

  handleTaxonomyChange = e => {
    const cats = isArray(e) ? e : [e]
    const page = 1
    this.props.findPosts({
      target: this.state.target,
      reset: true,
      cats,
      page,
      limit: this.state.limit
    })
    this.setState({
      cats,
      month: null,
      year: null,
      currentPage: page
    })
  }

  handleMonthChange = month => {
    const year = month !== null ? this.state.year /*|| (new Date()).getFullYear()*/: null
    const after = month !== null ? new Date(year, month, 1) : undefined
    const before = month !== null ? new Date(year, month + 1, 0) : undefined
    this.props.findPosts({
      target: this.state.target,
      reset: true,
      cats: this.state.cats,
      after,
      before,
      page: 1,
      limit: this.state.limit
    })
    this.setState({
      month,
      year,
      currentPage: 1
    })
  }

  handleYearChange = year => {
    const after = year !== null ? new Date(year, 0, 0) : undefined
    const before = year !== null ? new Date(year, 12, 0) : undefined
    this.props.findPosts({
      target: this.state.target,
      reset: true,
      cats: this.state.cats,
      after,
      before,
      page: 1,
      limit: this.state.limit
    })
    this.setState({
      month: null,
      year,
      currentPage: 1
    })
  }

  paginate = ({ current, number }) => {
    let offset = 0
    if (current === 1) offset = 2
    if (current === 2) offset = 1
    if (current === number) offset = -2
    if (current === number -1) offset = -1

    let first = 1
    let nBefore = first < current + offset - 2 ? '...' : null
    let n1 = current + offset - 1
    let n2 = current + offset
    let n3 = current + offset + 1
    let nAfter = number > current + offset + 2 ? '...' : null
    let last = number

    let result = [ first, nBefore, n1, n2, n3, nAfter, last ].filter(index => (index >= 1 && index <= number) || (index === '...')).filter((index, key, self) => self.indexOf(index) === key || index === '...')

    return result
  }

  static getDerivedStateFromProps(props, state) {
    // FIXME: if is fetching?
    const grid = props.grids[props.gridId]
    if (grid === undefined)
      return null

    if (grid.getCode() !== null && grid.getCode() !== 200)
      return { error: 'err.loadingGrid' }

    // FIXME: if is fetching?
    if (isEmpty(props.cats.items))
      return null

    if (props.cats.code !== null && props.cats.code !== 200)
      return { error: {keys: 'err.loadingCat', options: { count: 100 }} }

    const catsByTarget = {}
    Object.keys(props.cats.items).forEach(key => {
      catsByTarget[props.cats.items[key].getTarget()] = props.cats.items[key]
    })
    // FIXME: if is fetching?
    const pagination = props.pagination[state.target]
    if (pagination === undefined)
      return null

    if (pagination.code !== null && pagination.code !== 200)
      return { error: {keys: 'err.loadingPost', options: { count: 100 }} }

    return {
      grid,
      posts: pagination.ids.map(id => props.posts[id]),
      catsByTarget,
      error: null,
      nextPage: pagination.nextPage,
      isFetching: pagination.isFetching
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      // this.props.className !== prevProps.className ||
      this.props.gridId !== prevProps.gridId ||
      !isEqual(this.props.taxonomies, prevProps.taxonomies) ||
      this.props.number !== prevProps.number ||
      this.props.limit !== prevProps.limit ||
      // this.props.showFilter !== prevProps.showFilter ||
      // this.props.filterDefault !== prevProps.filterDefault ||
      this.props.paginationStyle !== prevProps.paginationStyle
    ) {
      const state = {
        grid: null,
        posts: null,
        error: null,
        target: this.state.target, //'VCBasicGrid_' + uuidv4(),
        cats: [this.props.taxonomies[0]],
        month: null,
        year: null,
        limit: this.props.paginationStyle ? this.props.number : this.props.limit,
        currentPage: 1, // FIXME: should be set by API response (as nextPage is set)
        nextPage: null,
        isFetching: null
      }
      this.setState(state)

      if (this.props.grids[this.props.gridId] === undefined)
        this.props.getGrid(this.props.gridId)

      if (isEmpty(this.props.cats.items) || (this.props.cats.code !== null && this.props.cats.code !== 200))
        this.props.findAllCats()

      // if (this.props.pagination[state.target] === undefined)
        this.props.findPosts({
          target: state.target,
          reset: true,
          cats: state.cats,
          limit: state.limit
        })

    }
    if (this.props.showFilter && this.props.location.hash && this.props.location.hash.indexOf('#taxonomy-') === 0 && this.props.location.hash !== prevProps.location.hash) {
      const taxonomy = parseInt(this.props.location.hash.replace('#taxonomy-', ''), 10)
      if (this.props.taxonomies.find(_taxonomy => _taxonomy === taxonomy)) this.handleTaxonomyChange(taxonomy)      
    }
  }

  render() {
    // FIXME: when api connection error (f.e. no cats response), this.state.grid is null and the notification will be misleading

    if (this.state.error)
      return <Error>{this.props.t(this.state.error.keys || this.state.error, this.state.error.options)}</Error>

    if (this.state.grid === null)
      return <Spinner>{this.props.t('msg.loadingGrid')}</Spinner>

    if (this.props.cats.items.length === 0)
      return <Spinner>{this.props.t('msg.loadingCat', { count: 100 })}</Spinner>

    if (this.state.posts === null)
      return <Spinner>{this.props.t('msg.loadingPost', { count: 100 })}</Spinner>

    // const currentCat = this.props.taxonomies.map(taxonomy => this.state.catsByTarget[taxonomy]).find(cat => isEqual([cat.getTarget()], this.state.cats))
    return (
      <div className={`grid${this.props.className?' '+this.props.className:''}`} ref={this.gridRef}>
        {this.props.showFilter && this.props.filterSize === 'lg' ?
          <div className='categories'>
            <CatBox items={[{value: this.props.taxonomies, name: this.props.filterDefault || this.props.t('lbl.all')}].concat(this.props.taxonomies.filter(taxonomy => this.state.catsByTarget[taxonomy] !== undefined).map(taxonomy => ({value: this.state.catsByTarget[taxonomy].getTarget(), name: this.state.catsByTarget[taxonomy].getTitle()})))} value={this.state.cats} onChange={this.handleTaxonomyChange} />
          </div>
        : null }
        {this.props.showFilter && this.props.filterSize !== 'lg' ?
          <div className='categories'>
            <CatBox items={this.props.taxonomies.filter(taxonomy => this.state.catsByTarget[taxonomy] !== undefined).map(taxonomy => ({value: this.state.catsByTarget[taxonomy].getTarget(), name: this.state.catsByTarget[taxonomy].getTitle()}))} value={this.state.cats} onChange={this.handleTaxonomyChange} />
          </div>
        : null }
        {this.props.showFilter && (!this.props.filterSize || this.props.filterSize === 'md' || this.props.filterSize === 'lg') ?
          <div className='date'>

            <label>{this.props.t('lbl.year')}</label>
            <SelectBox items={[{ value: null, name: this.props.t('lbl.all') }].concat(
              Array.from({length: 12}, (value, key) => ({ value: (new Date()).getFullYear() - key, name: (new Date()).getFullYear() - key }))
            )} value={this.state.year} onChange={this.handleYearChange} />

            <label>{this.props.t('lbl.month')}</label>
            <SelectBox items={[{ value: null, name: this.props.t('lbl.all') }].concat(this.props.t('months', { returnObjects: true }).map((month, key) => ({ value: key, name: month })))} value={this.state.month} onChange={this.handleMonthChange} />

          </div>
        : null }
        {this.state.posts.length > 0 ?
          this.state.posts.map((post, key) => (
            <RecursiveElement key={key} element={this.state.grid.getDom()} post={post} />
          ))
        :
          <Error>{this.props.t('err.notFound')}</Error>
        }
        {this.props.paginationStyle ?
          <div className={`pagination${this.props.pagination[this.state.target].totalPages <= 1 ? ' empty' : ''}`}>

            {this.state.currentPage > 1 ?
              <a className='prev page' onClick={this.handlePrevPage}>prev</a>
            :
              null
            }

            {this.paginate({ current: this.state.currentPage, number: this.props.pagination[this.state.target].totalPages }).map((v, k) => {
              if (v === '...') return <span className='dots' key={k}>{v}</span>
              if (v === this.state.currentPage) return <span className='current page' key={k}>{v}</span>
              return <a className='page' data-page={v} key={k} onClick={this.handlePageChange}>{v}</a>
            })}

            {this.state.nextPage ?
              <a className='next page' onClick={this.handleNextPage}>next</a>
            :
              null
            }

          </div>
        : null}
      </div>
    )
  }
}
const SelectLi = ({ children, className, value, handleChange }) => {
  const handleClick = () => {
    handleChange(value)
  }
  return (
    <li className={className} onClick={handleClick}>
      {children}
    </li>
  )
}

class SelectDD extends Component {

  state = {
    items: []
  }

  handleClickOutside = e => {
    this.props.handleToggle()
  }

  componentDidMount(){
    const updatedItems = this.props.items.filter((item) => {
      if (typeof item.name === 'string') {
        return item.name;
      }
      return item.name >= 2012
    })
    this.setState({
      items: updatedItems
    })  
  }
  render() {
    return (
      <div className={this.props.className}>
        <div className="selectbox-selected" onClick={this.props.handleToggle}>{this.props.items.find(item => item.value === this.props.value).name}</div>
        <div className="selectbox-options">
          <ul>
            {this.state.items.map((item) => (
              <SelectLi key={item.value} value={item.value} handleChange={this.props.handleChange}>{item.name}</SelectLi>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

const SelectDDContainer = onClickOutside(SelectDD)

class SelectBox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggle: false
    }
  }
  handleToggle = () => {
    this.setState({ toggle: !this.state.toggle })
  }
  handleChange = (value) => {
    this.setState({
      toggle: false
    })
    this.props.onChange(value)
  }
  render() {
    return (
      <SelectDDContainer className={`selectbox${this.state.toggle ? ' active' : ''}`} items={this.props.items} value={this.props.value} handleChange={this.handleChange} handleToggle={this.handleToggle} disableOnClickOutside={!this.state.toggle} />
    )
  }
}


const CatLi = ({ children, className, value, handleChange }) => {
  const handleClick = () => {
    handleChange(value)
  }
  return (
    <li onClick={handleClick}>
      <a className={className}>
        {children}
      </a>
    </li>
  )
}

class CatDD extends Component {
  handleClickOutside = e => {
    this.props.handleToggle()
  }
  // handleChange = (value) => {
  //   this.props.handleChange(value)
  // }
  render() {

    const item = this.props.items.find(item => isEqual(isArray(item.value)?item.value:[item.value], this.props.value))
    return (
      <div className={this.props.className}>
        <div className="selected-category" onClick={this.props.handleToggle}>{item ? item.name : ''}</div>
        <ul>
          {this.props.items.map((item) => (
            <CatLi key={item.value} className={isEqual(isArray(item.value)?item.value:[item.value], this.props.value) ? 'current category' : 'category'} value={item.value} handleChange={this.props.handleChange}>{item.name}</CatLi>
          ))}
        </ul>
      </div>
    )
  }
}

const CatDDContainer = onClickOutside(CatDD)

class CatBox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggle: false
    }
  }
  handleToggle = () => {
    this.setState({ toggle: !this.state.toggle })
  }
  handleChange = (value) => {
    this.setState({
      toggle: false
    })
    this.props.onChange(value)
  }
  render() {
    return (
      <CatDDContainer className={`categories-list${this.state.toggle ? ' active' : ''}`} items={this.props.items} value={this.props.value} handleChange={this.handleChange} handleToggle={this.handleToggle} disableOnClickOutside={!this.state.toggle} />
    )
  }
}

export default translate()(withRouter(VCBasicGrid))



// WEBPACK FOOTER //
// ./src/components/VCBasicGrid.js